import { render, staticRenderFns } from "./VideoSurveillance.vue?vue&type=template&id=1d6c8a91&scoped=true"
import script from "./VideoSurveillance.vue?vue&type=script&lang=js"
export * from "./VideoSurveillance.vue?vue&type=script&lang=js"
import style0 from "./VideoSurveillance.vue?vue&type=style&index=0&id=1d6c8a91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c8a91",
  null
  
)

export default component.exports